import {useEffect, useState} from "react";
import {Route, Routes, useParams, useMatch, useSearchParams} from "react-router-dom";
import {SettlementCompanies} from "../SettlementCompanies/SettlementCompanies";
import baseUrl from "../../baseUrl";
import {useAuthContext} from "../../contexts/AuthContext";
import {useNavigate} from "react-router-dom";
import {DeclareSettlement} from "./DeclareSettlement/DeclareSettlement";
import {requester} from "../../services/requester";
import {RouteGuard} from "../common/RouteGuard";

export const Settlements = () => {
    const navigate = useNavigate();
    const {setLocalStorageState} = useAuthContext();
    const {year} = useParams();
    const [settlements, setSettlements] = useState([]);
    const request = requester();

    // Списъкът със землища се показва само когато не сме навлезли в конкретно
    // землище (route-driven, вместо старото isShown състояние).
    const inSettlement = useMatch('/:year/settlements/:settlement_ekatte/*');

    useEffect(() => {
        request.get(`${baseUrl()}/companies-initial-info/${year}/ids`)
            .then(data => {
                if (data.message) {
                    setLocalStorageState({})
                    navigate("/login")
                }
                setSettlements(data);
            });

    }, [year]);

    // С2: землищата са групирани по ОБЩИНА и всяка община се разгъва при
    // щракване. При 30 села от различни общини подреденият по ЕКАТТЕ списък не
    // се чете — човек търси „моите села в еди-коя си община", а не номер.
    // Разгъната е по една община: щом отвориш друга, предишната се събира, за
    // да не расте страницата. Общините са подредени по азбучен ред.
    const byMunicipality = settlements.reduce((acc, s) => {
        const key = s.municipality || 'Без община';
        (acc[key] = acc[key] || []).push(s);
        return acc;
    }, {});
    const municipalities = Object.keys(byMunicipality).sort((a, b) => a.localeCompare(b, 'bg'));

    // Ако общината е една, няма какво да се избира — отваря се веднага.
    const [openMunicipality, setOpenMunicipality] = useState(null);
    // Щ2: „общ. Х" от пътечката идва с `?m=` и отваря точно тази община.
    // Държи се като НАЧАЛНО състояние, не като наложено: човек може да я
    // затвори или да отвори друга, без адресът да я връща обратно.
    const [searchParams] = useSearchParams();
    const отАдреса = searchParams.get('m');
    const [приложенАдрес, setПриложенАдрес] = useState(null);
    useEffect(() => {
        if (отАдреса && отАдреса !== приложенАдрес) {
            setOpenMunicipality(отАдреса);
            setПриложенАдрес(отАдреса);
        }
    }, [отАдреса, приложенАдрес]);
    const effectiveOpen = municipalities.length === 1 ? municipalities[0] : openMunicipality;

    const toggle = (m) => setOpenMunicipality(prev => (prev === m ? null : m));

    return (
        <div>
            {!inSettlement && (
                <div className="mt-2">
                    {municipalities.length === 0 && (
                        <p className="text-muted">Няма землища с данни за тази стопанска година.</p>
                    )}

                    {municipalities.map(m => {
                        const rows = byMunicipality[m];
                        const isOpen = effectiveOpen === m;
                        return (
                            <div key={m} className="card mb-2">
                                <button type="button"
                                        className="card-header d-flex justify-content-between align-items-center w-100 text-start"
                                        style={{
                                            cursor: "pointer",
                                            border: "none",
                                            background: "transparent",
                                            color: "var(--app-gold)",
                                            fontWeight: 600,
                                        }}
                                        aria-expanded={isOpen}
                                        onClick={() => toggle(m)}>
                                    <span>
                                        {isOpen ? '▾' : '▸'} община {m}
                                        <span className="text-muted fw-normal ms-2">
                                            ({rows.length} {rows.length === 1 ? 'землище' : 'землища'})
                                        </span>
                                    </span>
                                    <span className="text-muted fw-normal small">
                                        {rows[0]?.region ? `област ${rows[0].region}` : ''}
                                    </span>
                                </button>

                                {isOpen && (
                                    <div className="card-body p-0">
                                        <table className="table mb-0">
                                            <thead className="tableHead">
                                            <tr>
                                                <th scope="col">EKATTE</th>
                                                <th scope="col">Селище</th>
                                                <th scope="col">Община</th>
                                                <th scope="col">Област</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {rows.map(settlement => (
                                                <DeclareSettlement key={settlement.id} {...settlement}/>
                                            ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            )}


            <Routes element={<RouteGuard/>}>
                <Route path="/:settlement_ekatte/*" element={<SettlementCompanies/>}/>
            </Routes>

        </div>
    );
};